import { useRef, useState, useCallback } from 'react'
import { useRenderPdf } from '@hook/useRenderPdf'
import ScrollableDocumentViewer from '@components/collection/DocumentViewerV3/ScrollableDocumentViewer'
import config from '@/config'

const url = `${config.parseApiBaseUrl}/api/v1/pdfs/files/1973-00007118.pdf`

const KSRenderPdf = () => {
    
    const refCanvas = useRef()
    
    const [pageCount, setPageCount] = useState(0)
    const [pageIndex, setPageIndex] = useState(0)
    
    const handleError = useCallback(e => {
        console.error('handleError', e)
    }, [])
    
    useRenderPdf({
        // enabled: !!viewModel.refDocumentCanvas.current,
        url,
        pageIndex,
        setPageCount,
        getCanvas: () => refCanvas.current,
        onError: handleError,
        
        // onBeforeRender: onBeforePdfRender,
        // onAfterRender: onAfterPdfRender,
    })
    
    return (
        
        <div id="KSRenderPdf" className="grid grid-cols-2 gap-4">
            
            <div>
                
                <header>
                    
                    <div className="flex items-center content-center justify-center gap-4">
                        
                        <button className="btn">
                            &larr; PREV
                        </button>
                        
                        <input
                            className="w-20 text-center bg-transparent input input-bordered"
                            type="number"
                            value={pageIndex + 1}
                            onChange={e => setPageIndex(parseInt(e.target.value, 10) - 1)} />
                        
                        <span>/ {pageCount}</span>
                        
                        <button className="btn">
                            NEXT &rarr;
                        </button>
                    
                    </div>
                
                </header>
                
                <div className="w-1/2 mx-auto mt-2">
                    <canvas
                        ref={refCanvas}
                        className="w-full min-h-[80%] border border-red-500"/>
                </div>
            
            </div>
            
            <div>
                
                <header>scrollable version</header>
                
                <ScrollableDocumentViewer url={url} />
            
            </div>
        
        </div>
        
    )
    
}

export default KSRenderPdf
